@if (value$ | async; as progress) {
  <mat-progress-bar [value]="progress" color="accent"></mat-progress-bar>
}
